export default __webpack_public_path__ + "static/media/hdfc-ergo.99957927.png";